'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _readmissions = require('./readmissions.html');

var _readmissions2 = _interopRequireDefault(_readmissions);

var _readmissions3 = require('./readmissions.controller');

var _readmissions4 = _interopRequireDefault(_readmissions3);

require('./readmissions.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var readmissionsComponent = {
  restrict: 'E',
  bindings: {},
  template: _readmissions2.default,
  controller: _readmissions4.default,
  controllerAs: 'vm'
};

exports.default = readmissionsComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/readmissions/readmissions.component.js